import React from 'react';
import { FiCheck, FiMinus } from 'react-icons/fi';
import { useLanguage } from '../../context/LanguageContext';
import './EncounterChecklist.css';

const labels = {
  en: { title: 'Encounter overview', questions: 'Questions asked', reports: 'Reports requested', diagnosis: 'Diagnosis drafted', plan: 'Management plan drafted', yes: 'Yes', no: 'Not yet' },
  ru: { title: 'Обзор приёма', questions: 'Задано вопросов', reports: 'Запрошено результатов', diagnosis: 'Диагноз записан', plan: 'План лечения записан', yes: 'Да', no: 'Пока нет' },
  uz: { title: 'Qabul sharhi', questions: 'Berilgan savollar', reports: 'So‘ralgan natijalar', diagnosis: 'Tashxis yozilgan', plan: 'Davolash rejasi yozilgan', yes: 'Ha', no: 'Hali yo‘q' }
};

// These are activity/draft indicators, never an assessment of clinical quality.
export default function EncounterChecklist({ transcript = [], diagnosis = '', managementPlan = '' }) {
  const { language } = useLanguage();
  const copy = labels[language] || labels.en;
  const questions = transcript.filter(message => message.role === 'user' && !message.investigation_id).length;
  const reports = new Set(transcript.map(message => message.investigation_id).filter(Boolean)).size;
  const rows = [[copy.questions, questions > 0, questions], [copy.reports, reports > 0, reports], [copy.diagnosis, Boolean(diagnosis.trim())], [copy.plan, Boolean(managementPlan.trim())]];
  return <section className="encounter-checklist" aria-label={copy.title}><h3>{copy.title}</h3>{rows.map(([label, done, count]) => <div key={label}><span aria-hidden="true">{done ? <FiCheck /> : <FiMinus />}</span><span>{label}</span><strong>{count ?? (done ? copy.yes : copy.no)}</strong></div>)}</section>;
}
